"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const react_suspender_1 = __importDefault(require("react-suspender"));
const ErrorTypes_1 = require("../../../lib/errors/ErrorTypes");
const MapmakerApi_1 = require("../../../client/MapmakerApi");
const SanityContent_1 = __importDefault(require("./SanityContent"));
const useMapmakerTitle_1 = require("../../../lib/hooks/useMapmakerTitle");
(0, graphql_tag_1.default) `
  fragment Page on Page {
    _id
    title
    slug {
      current
    }
    contentRaw
  }

  query pageBySlug($slug: String!) {
    allPage(where: { slug: { current: { eq: $slug } } }) {
      ...Page
    }
  }
`;
function SanityPage({ slug, useAsPageTitle = false, }) {
    const { data, loading, error } = (0, MapmakerApi_1.usePageBySlugQuery)({
        variables: {
            slug,
        },
    });
    const page = data === null || data === void 0 ? void 0 : data.allPage[0];
    (0, useMapmakerTitle_1.useMapmakerTitle)((page === null || page === void 0 ? void 0 : page.title) && useAsPageTitle ? page.title : window.document.title);
    if (loading) {
        return (0, jsx_runtime_1.jsx)(react_suspender_1.default, {});
    }
    else if (error || !page) {
        throw new ErrorTypes_1.PageNotFoundError({ message: "We could not find this page." });
    }
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("h1", { children: page.title }), (0, jsx_runtime_1.jsx)(SanityContent_1.default, { content: page.contentRaw })] }));
}
exports.default = SanityPage;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU2FuaXR5UGFnZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL2hlbHAvc2FuaXR5L1Nhbml0eVBhZ2UudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBLDhEQUE4QjtBQUM5QixzRUFBd0M7QUFDeEMsK0RBQW1FO0FBQ25FLDZEQUFpRTtBQUNqRSxvRUFBNEM7QUFDNUMsMEVBQXVFO0FBRXZFLElBQUEscUJBQUcsRUFBQTs7Ozs7Ozs7Ozs7Ozs7O0NBZUYsQ0FBQztBQU9GLFNBQXdCLFVBQVUsQ0FBQyxFQUNqQyxJQUFJLEVBQ0osY0FBYyxHQUFHLEtBQUssR0FDTDtJQUNqQixNQUFNLEVBQUUsSUFBSSxFQUFFLE9BQU8sRUFBRSxLQUFLLEVBQUUsR0FBRyxJQUFBLGdDQUFrQixFQUFDO1FBQ2xELFNBQVMsRUFBRTtZQUNULElBQUk7U0FDTDtLQUNGLENBQUMsQ0FBQztJQUNILE1BQU0sSUFBSSxHQUFHLElBQUksYUFBSixJQUFJLHVCQUFKLElBQUksQ0FBRSxPQUFPLENBQUMsQ0FBQyxDQUFDLENBQUM7SUFDOUIsSUFBQSxtQ0FBZ0IsRUFDZCxDQUFBLElBQUksYUFBSixJQUFJLHVCQUFKLElBQUksQ0FBRSxLQUFLLEtBQUksY0FBYyxDQUFDLENBQUMsQ0FBQyxJQUFJLENBQUMsS0FBSyxDQUFDLENBQUMsQ0FBQyxNQUFNLENBQUMsUUFBUSxDQUFDLEtBQUssQ0FDbkUsQ0FBQztJQUVGLElBQUksT0FBTyxFQUFFO1FBQ1gsT0FBTyx1QkFBQyx5QkFBUyxLQUFHLENBQUM7S0FDdEI7U0FBTSxJQUFJLEtBQUssSUFBSSxDQUFDLElBQUksRUFBRTtRQUN6QixNQUFNLElBQUksOEJBQWlCLENBQUMsRUFBRSxPQUFPLEVBQUUsOEJBQThCLEVBQUUsQ0FBQyxDQUFDO0tBQzFFO0lBQ0QsT0FBTyxDQUNMLDRDQUNFLHlDQUFLLElBQUksQ0FBQyxLQUFLLEdBQU0sRUFDckIsdUJBQUMsdUJBQWEsSUFBQyxPQUFPLEVBQUUsSUFBSSxDQUFDLFVBQVUsR0FBSSxJQUN2QyxDQUNQLENBQUM7QUFDSixDQUFDO0FBekJELDZCQXlCQyJ9